import type { UpdateSystem } from "@engine/core/Lifecycle";
import type { CollisionMap } from "@engine/world";
import type { Entity } from "../components";
import type { EcsWorld } from "../world";

/**
 * Applies velocity to position. Optionally honors a CollisionMap
 * doing per-axis sweep so entities slide along walls.
 */
export class MovementSystem implements UpdateSystem {
  private query;

  constructor(
    world: EcsWorld,
    private readonly collision?: CollisionMap,
  ) {
    this.query = world.with("position", "velocity").without("asleep");
  }

  update(dt: number): void {
    for (const e of this.query) this.step(e, dt);
  }

  private step(e: Entity, dt: number): void {
    const pos = e.position;
    const vel = e.velocity;
    if (!pos || !vel) return;
    const r = e.sprite?.radius ?? 0;
    const dx = vel.x * dt;
    const dy = vel.y * dt;

    if (!this.collision) {
      pos.x += dx;
      pos.y += dy;
      return;
    }
    const tryX = pos.x + dx;
    if (!this.collision.circleBlocked(tryX, pos.y, r)) pos.x = tryX;
    const tryY = pos.y + dy;
    if (!this.collision.circleBlocked(pos.x, tryY, r)) pos.y = tryY;
  }
}
